
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/love",
      function () {
        return require("private-next-pages/love.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/love"])
      });
    }
  